exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-user .image {\n\theight: 60px;\n\t/* background-color: black; */\n}\n\n.avatar {\n\tbackground-color: white;\n}\n\n.card-user .content {\n\tmin-height: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/user/user.component.css
// module id = ../../../../../src/app/user/user.component.css
// module chunks = main